module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main